<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-back-button></ion-back-button>
    </ion-buttons>
    <ion-title>{{title}}</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  <div class="logo logo-top"></div>
  <div class="logo logo-bottom"></div>
  <div style="text-align: center;" *ngIf="contactUsHtml$ | async; let contactUs" [innerHTML]="contactUs"></div>
</ion-content>